// Shared permission/feature checkbox cell used by the access matrices in
// WebAccessPage and MobileAccessTab. Both pages inlined this exact markup — a
// <label> wrapping a rounded box that fills in (primary background + white
// check svg) when checked, toggling on click. The two sites differed only in
// the click handler (togglePermission vs toggleFeature) and the source of the
// checked flag, exposed here as `onToggle` and `checked`. The className
// template literal (including its embedded newline + trailing whitespace) is
// reproduced verbatim so the rendered class attribute is byte-identical.
interface PermissionCheckboxCellProps {
  /** Whether this role currently has the permission/feature — drives the
   *  filled box styling and whether the check svg renders. */
  checked: boolean;
  /** Fired when the box is clicked. Each site passes its own
   *  `() => togglePermission(...)` / `() => toggleFeature(...)` closure. */
  onToggle: () => void;
}

export function PermissionCheckboxCell({ checked, onToggle }: PermissionCheckboxCellProps) {
  return (
    <label className="inline-flex items-center justify-center cursor-pointer group">
      <div
        className={`w-5 h-5 rounded border-2 flex items-center justify-center transition-all duration-200
          ${checked
            ? 'bg-primary-600 border-primary-600 shadow-sm'
            : 'border-gray-300 bg-white group-hover:border-primary-400'
          }
        `}
        onClick={onToggle}
      >
        {checked && (
          <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        )}
      </div>
    </label>
  );
}

export default PermissionCheckboxCell;
